export var ModalOptions;
(function (ModalOptions) {
    ModalOptions["refundRequest"] = "refund-request";
    ModalOptions["success"] = "success";
    ModalOptions["error"] = "error";
    ModalOptions["inProgress"] = "in-progress";
    ModalOptions["refundError"] = "refund-error";
    ModalOptions["default"] = "default";
})(ModalOptions || (ModalOptions = {}));
